/**
 * Timeline Class
 * Handles timeline slider functionality
 */
class Timeline {
  constructor(element) {
    this.$element = $(element);
    this.timelineSlider = this.$element.find('.timeline-slider');
    this.init();
  }

  /**
   * Initialize the timeline
   */
  init() {
    this.initSlider();
    this.bindEvents();
  }

  /**
   * Initialize the slick slider
   */
  initSlider() {
    if (this.timelineSlider.length) {
      this.timelineSlider.slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev text-h2"><i class="icomoon icon-arrow-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next text-h2"><i class="icomoon icon-arrow-right"></i></button>',
        appendArrows: this.$element.find('.timeline-slider__arrows'),
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 650,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  }

  /**
   * Bind events
   */
  bindEvents() {
    $(window).on('resize', this.handleResize.bind(this));
  }

  /**
   * Handle window resize
   */
  handleResize() {
    // Refresh slider on resize if needed
    if (this.timelineSlider.length) {
      this.timelineSlider.slick('refresh');
    }
  }
}

// Initialize Timeline when document is ready
$(document).ready(() => {
  const $timeline = $('.gravity-timeline');
  if ($timeline.length) {
    $timeline.each((_index, element) => {
      new Timeline(element);
    });
  }
});
